import { IGeneralAppState } from '@GameStore/GameStoreSchema';
import { IAccount } from '@GFTypes/GameStoreTypes/Account';

export const APP_STATE_DEFAULTS: IGeneralAppState = {
    insufficientFunds: true,
    error: undefined
};
